import React, { useEffect, useLayoutEffect, useState } from 'react';
import { connect, useStore } from 'react-redux';
import { Link, useHistory } from "react-router-dom";
import useMedia from 'use-media';
import commonUtil from '../../../common/commonUtil';
import { apiKeyCheck, getServiceCheck, versionGetApi } from '../../../const';
import Const from '../../../const/Const';
import messageConst from '../../../const/messageConst';
import common from '../../../resources/js/common/common';
import { Button } from '../../atoms/button';
import { BreadCrumb } from '../../molecules/breadCrumb';
import { ErrorMassage } from '../../molecules/errorMassage';
import { ImportedInfoComf } from '../../molecules/importedInfoComf';
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import './../../../resources_membership_hotel/css/common/privilege_icon.css';
import './../../../resources_membership_hotel/css/hotel/membership_reserve_cancel.css';
import './../../../resources_membership_hotel/css/esthetic/bookingConfirm.css';
import { useRtoaster } from '../../../hooks/useRtoaster';

const ImportedBookingConfirmContainer = (props) => {
    const {
        login,
        importedReserveComf,
        setImportedReserveComf,
        onClickOpenCancelPopupWindow,
        restaurantReserveInfo,
        setRestaurantReserveInfo,
        setMembershipCancelReserveComf,
        setRestaurantInfo,
        resvKaiinken,
        serviceCheckInfo,
        setServiceCheckInfo,
        setLoginType,
    } = props;

    const loginType = login.loginType;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const store = useStore();
    const history = useHistory();

    //表示用ステート
    const [reserveInfo,setReserveInfo] = useState({});
    const [reserveMealInfo,setReserveMealInfo] = useState([]);
    const [linkList, setLinkList] = useState([]);
    const isCrawl = login.loginType === 'CRAWL';

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessageBox: [], errorFlg: false, });

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if(Object.keys(state).length !== 0){
            apiKey = state.apiKey;
        }
        if(apiKey === null){
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
        if(apiKey){
            common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if(!res.data){
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        //予約内容のセット
        if(importedReserveComf != undefined && Object.keys(importedReserveComf).length != 0){
            reserveInfoSet();
            setReserveMealInfo(importedReserveComf.foodList);
        }
        if (!loginType || loginType === "MEMBER" && importedReserveComf.cornerBunKbn == "1") {
            setLinkList([{ path: "/reserve/top", label: "HOME" }]);
        } else if (loginType === "CRAWL") {
            setLinkList([{ path: "/reserve/hotel/crawlSearch", label: "CRAWL検索画面" }]);
        }
        setErrorInfo({ errorMessageBox: [], errorFlg: false, })

        // サービスチェック取得
        requestGetServiceCheck();

        // ログインタイプ取得
        setLoginType(loginType);
    }, [importedReserveComf]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // プラン変更可能チェック
    const checkChangePlan = () => {
        let errorFlg = false;
        let errorMessageBox = [];
        let strToday = commonUtil.getStringFromDate(new Date(), "yyyy-MM-dd");
        const termCnt = commonUtil.getNights(strToday, importedReserveComf.checkInDate, "-") + 1;
        if (termCnt <= Const.IMPORTED_CHANGEABLE_TERM) {
            errorFlg = true;
            errorMessageBox.push(messageConst.IMPORTED_CHANGE_LIMIT_ERROR);
            setErrorInfo({errorFlg: errorFlg, errorMessageBox: errorMessageBox});
            return !errorFlg;
        }
        let availableFlg = false;
        if (importedReserveComf.keiyakuNo == Const.GENERAL_CONTRACT_NO) {
            availableFlg =true;
        } else {
            login.memberInfo?.forEach(info => {
                info.memberList?.data.kaiinInfoList.forEach(value => {
                    if (importedReserveComf.keiyakuNo == value.keiyakuNo) {
                        availableFlg = true;
                    }
                })
            })
        }
        if (!isCrawl && !availableFlg) {
            errorFlg = true;
            errorMessageBox.push(messageConst.ILLEGAL_RESERVE_ERROR);
            setErrorInfo({errorFlg: errorFlg, errorMessageBox: errorMessageBox});
            return !errorFlg;
        }
        const foodList = importedReserveComf.foodList;
        if (foodList && foodList.length > 0) {
            let foodErrFlg = false;
            foodList.forEach(foodInfo => {
                let dinnerCnt = 0;
                let breakfastCnt = 0;
                foodInfo.foodTimeList?.forEach(value => {
                    if (value.jikantaiKbn == "2") {
                        dinnerCnt++;
                    } else if (value.jikantaiKbn == "3") {
                        breakfastCnt++;
                    }
                })
                if (dinnerCnt > 1 || breakfastCnt > 1) {
                    foodErrFlg = true;
                }
            })
            if (foodErrFlg) {
                errorFlg = true;
                errorMessageBox.push(messageConst.ILLEGAL_RESERVE_ERROR);
            }
        }
        setErrorInfo({errorFlg: errorFlg, errorMessageBox: errorMessageBox});
        return !errorFlg;
    }

    // サービスチェック取得処理
    const requestGetServiceCheck = () => {
        if (!importedReserveComf) return;

        // サービスチェック取得
        const req = {
            keiyakuNo: importedReserveComf.keiyakuNo,
            shisetsuCd: importedReserveComf.shisetsuCd,
            riyoDate: importedReserveComf.checkInDate,
            hakuCnt: importedReserveComf.hakuCnt,
            tsuzukigaraCd: importedReserveComf.relationCd,
            roomTypeList: [],
            riyoKaiinkenSyubetCd: importedReserveComf.riyoKaiinkenSyubetCd,
        }
        common.doPost(getServiceCheck, req, afterGetServiceCheck);
    }

    // サービスチェック取得後処理
    const afterGetServiceCheck = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            setServiceCheckInfo({
                kozafurikaeKanoKbn: data.kozafurikaeKanoKbn,
                kozafurikaeKiyakuMongon: data.kozaMongon,
                sciKanoFlg: data.sciKanoFlg,
                sciKiyakuMongon: data.sciMongon,
                scoKanoFlg: data.scoKanoFlg,
                scoKiyakuMongon: data.scoMongon,
                nonstopCheckInKanoFlg: data.nonstopCheckinKanoFlg,
                nonstopKiyakuMongon: data.nonstopMongon,
                kenrishokaYoFlg: data.kenrishokaYoFlg,
                homeFlKanoFlg: data.homeFlKanoFlg
            });
        }
    }

    //予約内容セット
    const reserveInfoSet = () =>{
        let reserveObj = {
            checkin:dateForm(importedReserveComf.checkInDate),
            checkout:dateForm(importedReserveComf.checkOutDate),
            facilityName: importedReserveComf.shisetsuName,
            // 予約するときに素泊まりはplanCdを連携しない仕様なので取得できない
            reservationNo:importedReserveComf.yoyakuNo,
            machiFlg: importedReserveComf.machiFlg,
            ownerNo: importedReserveComf.ownerNo,
            adultDinnerRyokin: importedReserveComf.adultDinnerRyokin,
        }
        setReserveInfo(reserveObj);
    }
   
    //yyyy-mm-ddをyyyy年mm月dd日(曜日)形式に変換
    const dateForm = (res) => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        var dateArr = res.split("-")
        let date = new Date(dateArr[0],dateArr[1] - 1,dateArr[2]);
        let convert = dateArr[0]+ "年" +dateArr[1].replace(/^0+/, '')+ "月" + dateArr[2].replace(/^0+/, '')+ "日" + "(" +  youbi[date.getDay()]+ ")";

        return convert;
    }

    const getInputUserInfo = () => {
        let adultSum = 0;
        let womenSum = 0;
        let childSum = 0;
        let preschoolerSum = 0;
        let babySum = 0;
        let riyoDate = "";
        let startTime = "";
        let jikantaiKbn = "";
        let restaurantCd = "";
        
        importedReserveComf.foodList.forEach(foodObj => {
            foodObj.foodTimeList?.forEach(foodTimeObj => {
                adultSum += Number(foodTimeObj.adultCnt);
                womenSum += Number(foodTimeObj.womenCnt)
                childSum += Number(foodTimeObj.childCnt)
                preschoolerSum += Number(foodTimeObj.preschoolerCnt)
                babySum += Number(foodTimeObj.babyCnt)
            })
        })
        const ret = {
            allergyKbn: importedReserveComf.allergyKbn,
            allergyBiko: importedReserveComf.allergyBiko,
            foodRequest: importedReserveComf.foodRequest,
            daihyouName: importedReserveComf.daihyouName,
            daihyouNameKana: importedReserveComf.daihyouNameKana,
            mainPhoneKbn: importedReserveComf.mainPhoneKbn,
            mainPhoneNumber: importedReserveComf.mainPhoneNumber,
            contactPhoneNumber: importedReserveComf.contactPhoneNumber,
            contactMailAddress: importedReserveComf.contactMailAddress,
            relationCd: importedReserveComf.relationCd,
            prefectureCd: importedReserveComf.prefectureCd,
            transportCd: importedReserveComf.transportCd,
            carCnt: importedReserveComf.carCnt,
            busTime: importedReserveComf.busTime,
            kozafurikaeFlg: importedReserveComf.kozafurikaeFlg,
            biko: importedReserveComf.biko,
            kakuninMailKiboKbn: importedReserveComf.kakuninMailKiboKbn,
            confirmReserveMail: importedReserveComf.kakuninMailKiboKbn ? importedReserveComf.kakuninMailAddress : ""
        };
        return ret;
    }

    //人数・時間変更ボタン
    const onClickTimeChange = () => {
        // 変更可能チェック
        if (checkChangePlan()) {
            // 予約内容取得処理
            let adultSum = 0;
            let childSum = 0;
            let preschoolerSum = 0;
            let babySum = 0;
            let riyoDate = "";
            let startTime = "";
            let jikantaiKbn = "";
            let restaurantCd = "";
            let restaurantName = "";
            let courseList = [];

            const foodTimeObj = importedReserveComf.foodList?.[0]?.foodTimeList?.[0];
            adultSum = Number(foodTimeObj.adultCnt);
            childSum = Number(foodTimeObj.childCnt)
            preschoolerSum = Number(foodTimeObj.preschoolerCnt)
            babySum = Number(foodTimeObj.babyCnt)
            riyoDate = foodTimeObj.riyoDate;
            startTime = foodTimeObj.startTime;
            jikantaiKbn = foodTimeObj.jikantaiKbn;
            courseList = (foodTimeObj.courseList.map(value => {
                return { courseCd: value.foodCourseCd, courseName: value.foodCourseName, courseNum: value.targetCnt, tanka: value.courseTanka }
            }))
            restaurantCd = foodTimeObj.restaurantCd;
                    restaurantName = foodTimeObj.restaurantName;
            setImportedReserveComf({ ...importedReserveComf, pageKbn: "" });
            if (importedReserveComf.cornerBunKbn == "1"){
                const newRestaurantReserveInfo = {
                    peopleNum: adultSum + childSum + preschoolerSum + babySum,
                    adultCnt: adultSum,
                    childCnt: childSum,
                    preschoolerCnt: preschoolerSum,
                    babyCnt: babySum,
                    riyoDate: riyoDate,
                    yoyakuTime: startTime,
                    jikantai: jikantaiKbn,
                    courseList: courseList,
                    allergyExistence: importedReserveComf.allergyKbn,
                    allergyBiko: importedReserveComf.allergyBiko,
                    foodRequest: importedReserveComf.foodRequest,
                    daihyouName: importedReserveComf.daihyouName,
                    daihyouNameKana: importedReserveComf.daihyouNameKana,
                    mainPhoneKbn: importedReserveComf.mainPhoneKbn,
                    mainPhoneNumber: importedReserveComf.mainPhoneNumber,
                    contactPhoneNumber: importedReserveComf.contactPhoneNumber,
                    contactMailAddress: importedReserveComf.contactMailAddress,
                    relationCd: importedReserveComf.relationCd,
                    prefectureCd: importedReserveComf.prefectureCd,
                    transportCd: importedReserveComf.transportCd,
                    carCnt: importedReserveComf.carCnt,
                    busTime: importedReserveComf.busTime,
                    kozafurikaeFlg: importedReserveComf.kozafurikaeFlg,
                    biko: importedReserveComf.biko,
                    kakuninMailKiboKbn: importedReserveComf.kakuninMailKiboKbn,
                    confirmReserveMail: importedReserveComf.kakuninMailKiboKbn ? importedReserveComf.kakuninMailAddress : "",
                    yoyakuNo: importedReserveComf.yoyakuNo,
                    reserveFlg: importedReserveComf.reserveFlg,
                    reserveNo: importedReserveComf.reserveNo
                };
                setRestaurantInfo({
                    honkanShisetsuCd: importedReserveComf.honkanShisetsuCd,
                    restaurantCd: restaurantCd,
                    restaurantName: restaurantName,
                    shisetsuName: importedReserveComf.shisetsuName,
                    shisetsuCd: importedReserveComf.shisetsuCd,
                    yoyakuNo: importedReserveComf.yoyakuNo,
                    planCd: importedReserveComf.planCd,
                    planRyokinTotal: importedReserveComf.totalRoomPrice,
                    keiyakuNo: importedReserveComf.keiyakuNo,
                    riyoKaiinkenSyubetCd: importedReserveComf.riyoKaiinkenSyubetCd,
                    changeFlg: true,
                    changeType: 'member',
                    memberCd: resvKaiinken[0].memberCd,
                })
    
                setRestaurantReserveInfo(newRestaurantReserveInfo);
                history.push("/reserve/hotel/restaurantReserve");
            } else if (importedReserveComf.cornerBunKbn == "2") {
                // エステ予約変更
            }
        }
    }

    //キャンセル処理
    const onClickCancel = () => {
        // 変更可能チェック
        if (checkChangePlan()) {
            const foodTimeObj = importedReserveComf.foodList?.[0]?.foodTimeList?.[0];
            setMembershipCancelReserveComf({
                shisetsuCd: importedReserveComf.shisetsuCd,
                restaurantCd: foodTimeObj?.restaurantCd,
                riyoDate: foodTimeObj?.riyoDate,
                keiyakuNo: importedReserveComf.keiyakuNo,
                yoyakuNo: importedReserveComf.yoyakuNo
            });
            onClickOpenCancelPopupWindow()
        }
    }

    // 料金情報
    const priceInfo = () => {
        const dispPriceFlg = importedReserveComf.totalRoomPrice && importedReserveComf.totalRoomPrice != 0 && importedReserveComf.planCd &&
        (importedReserveComf.breakfastTsukiPlanFlg || importedReserveComf.dinnerTsukiPlanFlg || importedReserveComf.thanksFlg) && importedReserveComf.machiFlg === "0";
        if (dispPriceFlg) {
            return(
                <div className='membership_reserve_cancel_contentarea'>
                        <div className='membership_reserve_cancel_title'>
                        プラン料金
                        </div>
                    <div className='membership_reserve_cancel_body priceArea'>
                        <div className='membership_reserve_cancel_wid flex'>
                            <div className='membership_reserve_cancel_info3 price price_body'>￥{Number(importedReserveComf.totalRoomPrice).toLocaleString()}</div>
                        </div>
                        {/* <div className='membership_reserve_cancel_wid'>
                            <div className='priceComment redChar'>※ディナーチョイスプラン選択時には夕食代金は含まれません。上記料金に別途夕食代金を申し受けます。</div>
                            <div className='priceComment'>※ホテルにより宿泊税および入湯税を別途申し受けます。</div>
                        </div> */}
                    </div>
                </div>
            )
        } else {
            return null;
        }
    }

    return (
        <div>
            <div style={{marginLeft:"-40px"}}>
                <BreadCrumb
                    breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                    linkStyle={styles.link}
                    linkList={linkList}
                    lastLabel="予約内容確認"
                    lastLabelClassName="lastLabel"
                />
            </div>
            <div className={isWideTablet ? "membership_reserve_cancel_base2" : "membership_reserve_cancel_base"}>
                <div className='membership_reserve_cancel_contentarea'>
                    <div className='membership_reserve_cancel_title'>
                        ご予約内容
                    </div>
                    <div className='membership_reserve_cancel_body'>
                        <div className="reserveInfoContentBlock">
                            <div className='reservationContent lastContent'>
                                <div className='reserveInfoTitleGray block'>予約番号</div>
                                <div className='membership_reserve_cancel_info block'>{reserveInfo.reservationNo}</div>
                            </div>
                        </div>
                        <div className="reserveInfoContentBlock">
                            <div className='reservationContent lastContent'>
                                <div className='reserveInfoTitleGray block'>レストラン名</div>
                                <div className='importedRestaurantNameWrapper'>
                                    <div>{reserveInfo.facilityName}</div>
                                    <div>{reserveMealInfo?.[0]?.foodTimeList?.[0]?.restaurantName}</div>
                                </div>
                            </div>
                        </div>
                        <div className="reserveInfoContentBlock">
                            <div className='reservationContent lastContent'>
                                <div className='reserveInfoTitleGray'>ご利用日</div>
                                <div className='membership_reserve_cancel_info'>{reserveInfo.checkin}</div>
                            </div>
                        </div>
                        {/* 食事リストでマップする */}
                        <ImportedInfoComf data={reserveMealInfo} cornerBunKbn={importedReserveComf.cornerBunKbn} isWideTablet={isWideTablet} />
                    </div>
                </div>
                {importedReserveComf.cornerBunKbn == "1" ?
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            アレルギー
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_info'>{importedReserveComf.allergyKbn == "1" ? "あり" : importedReserveComf.allergyKbn == "2" ? "なし" : "わからない"}</div>
                            </div>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_subtitle'>アレルギー内容</div>
                                <div className='membership_reserve_cancel_info'>{importedReserveComf.allergyBiko}</div>
                            </div>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_subtitle'>食事要望</div>
                                <div className='membership_reserve_cancel_info'>{importedReserveComf.foodRequest}</div>
                            </div>
                        </div>
                    </div>
                    : null
                }
                {/* 料金エリア */}
                {priceInfo()}
            </div>
            <div className={isWideTablet ? "membership_reserve_cancel_base2" : "membership_reserve_cancel_base"} style={styles.topGrayBorder}>
                <div className="membership_reserve_cancel_contentarea">
                    <div className='membership_reserve_cancel_title'>
                        利用代表者
                    </div>
                    <div className='membership_reserve_cancel_body'>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            <div className='membership_reserve_cancel_subtitle'>氏名（カナ）</div>
                            <div className='membership_reserve_cancel_info'>{importedReserveComf.daihyouNameKana}</div>
                        </div>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            <div className='membership_reserve_cancel_subtitle'>氏名（漢字）</div>
                            <div className='membership_reserve_cancel_info'>{importedReserveComf.daihyouName}</div>
                        </div>
                    </div>
                </div>
                {importedReserveComf.mainPhoneKbn && (
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            利用代表者電話番号
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_subtitle'>{importedReserveComf.mainPhoneKbn == "1" ? "自宅" : importedReserveComf.mainPhoneKbn == "2" ? "会社" : "携帯"}</div>
                                <div className='membership_reserve_cancel_info'>{importedReserveComf.mainPhoneNumber}</div>
                            </div>
                        </div>
                    </div>
                )}
                {importedReserveComf.contactPhoneNumber && (
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            予約連絡先電話番号
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_info'>{importedReserveComf.contactPhoneNumber}</div>
                            </div>
                        </div>
                    </div>
                )}
                {importedReserveComf.contactMailAddress && (
                <div className="membership_reserve_cancel_contentarea">
                    <div className='membership_reserve_cancel_title'>
                        {"予約連絡先メールアドレス"}
                    </div>
                    <div className='membership_reserve_cancel_body'>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            <div className='membership_reserve_cancel_info2'>{importedReserveComf.contactMailAddress}</div>
                        </div>
                    </div>
                </div>
                )}
                {importedReserveComf.relationName && (
                  <div className="membership_reserve_cancel_contentarea">
                      <div className='membership_reserve_cancel_title'>
                          {"会員様とのご関係"}
                      </div>
                      <div className='membership_reserve_cancel_body'>
                          <div className='membership_reserve_cancel_wid five_padding'>
                              <div className='membership_reserve_cancel_info'>{importedReserveComf.relationName}</div>
                          </div>
                      </div>
                  </div>
                )}
                {serviceCheckInfo && serviceCheckInfo.kozafurikaeKanoKbn == "1" ?
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            {"口座振替精算"}
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_info'>{importedReserveComf.kozafurikaeFlg ? "希望する" : "希望しない"}</div>
                            </div>
                        </div>
                    </div>
                    : null
                }
                {importedReserveComf.biko && (
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            {"備考"}
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_info'>{importedReserveComf.biko}</div>
                            </div>
                        </div>
                    </div>
                )}
                {importedReserveComf.kakuninMailKiboKbn != undefined && importedReserveComf.kakuninMailKiboKbn != null ?
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            {"予約確認メール"}
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                {importedReserveComf.kakuninMailKiboKbn == "1" ?
                                    <>
                                        <div className='membership_reserve_cancel_info'>希望する</div>
                                        <div className='membership_reserve_cancel_info'>{importedReserveComf.kakuninMailAddress}</div>
                                    </>
                                    : <div className='membership_reserve_cancel_info'>希望しない</div>
                                }
                            </div>
                        </div>
                    </div>
                    : null
                }
                <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                    <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessageBox} />
                </div>
                {importedReserveComf.cancelKbn == "1" ?
                    <>
                        <div className={importedReserveComf.cornerBunKbn == "1" ? "membership_reserve_change_btn_area" : "hiddenItem"}>
                            <Button buttonText="人数・時間変更" onClick={onClickTimeChange} className="membership_reserve_time_btn" />
                        </div>
                        <div className={importedReserveComf.cornerBunKbn == "1" ? 'membership_reserve_cancel_btn_area' : "membership_reserve_change_btn_area"}>
                            <Button buttonText="予約をキャンセル" onClick={onClickCancel} className="membership_reservation_cancel_btn" />
                        </div>
                    </>
                    : null
                }
                {importedReserveComf.cornerBunKbn == "1" ?
                    <div className="backTopBookingConfirm">
                        <Link className='membership_reserve_cancel_link' to={"/reserve/hotel/restaurantReserveAll"} >レストラン予約TOPへ戻る</Link>
                    </div>
                    : null}
            </div>
            <div><MembershipFooterContainer footerClass={"reservationResultFooterBase grayFooter"} /></div>
        </div >
    )
}

const styles = {
    top: {
        width: "100%",
        // paddingTop: "50px",
        // paddingBottom: "50px",
        backgroundColor: "#ebebeb",
        // backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        // height: "calc(100vh - (9.8rem + 100px))",
    },
    topCancel: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "#ebebeb",
        // backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        // height: "calc(100vh - (7.1rem + 100px))",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        paddingTop: "15px",
        width: "70%",
        marginRight: "auto",
        marginLeft: "auto",
        paddingBottom: "40px"
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
    topGrayBorder: {
        borderTop: "solid 50px gray",
    },
}
const mapStateToProps = (state) => {
    return {
        login: state.login,
        importedReserveComf: state.importedReserveComf,
        restaurantReserveInfo: state.restaurantReserveInfo,
        membershipSearchParam: state.membershipSearchParam,
        resvKaiinken: state.resvKaiinken,
        serviceCheckInfo: state.serviceCheckInfo,
    };
};

const mapDisptchToProps = (dispatch) => {
    return {
        setImportedReserveComf: (item) => {
            dispatch({ type: "IMPORTED_RESERVE_COMF", payload: { importedReserveComf: item } })
        },
        setRestaurantInfo: (item) => {
            dispatch({ type: "RESTAURANT_INFO", payload: { restaurantInfo: item } })
        },
        setRestaurantReserveInfo: (item) => {
            dispatch({ type: "RESTAURANT_RESERVE_INFO", payload: { restaurantReserveInfo: item } })
        },
        setServiceCheckInfo: (item) => {
            dispatch({ type: "SERVICE_CHECK_INFO", payload: { serviceCheckInfo: item } })
        },
        setMembershipCancelReserveComf: (item) => {
            dispatch({ type: "MEMBERSHIP_CANCEL_RESERVE_COMF", payload: { membershipCancelReserveComf: item } })
        },
    };
};

export default connect(mapStateToProps, mapDisptchToProps)(ImportedBookingConfirmContainer);
